/* calo-cart-drawer.js */
(function() {
  'use strict';

  /* ── 1. Nav-Links in Drawer-Footer einfügen ── */
  function addNavLinks() {
    const ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (!ctas) return;
    if (ctas.querySelector('.cart-drawer__nav-links')) return;
    const nav = document.createElement('div');
    nav.className = 'cart-drawer__nav-links';
    nav.innerHTML =
      '<a href="/cart">🛒 Zur Warenkorbseite</a>' +
      '<span class="cart-drawer__nav-divider">|</span>' +
      '<a href="javascript:void(0)" class="calo-continue-shopping">← Weiter einkaufen</a>';
    ctas.appendChild(nav);
    nav.querySelector('.calo-continue-shopping').addEventListener('click', function() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
    });
  }

  /* MutationObserver: Links neu einføgen wenn Drawer-Inhalt aktualisiert */
  const drawerObserver = new MutationObserver(function() {
    addNavLinks();
  });
  function startObserver() {
    const drawerInner = document.querySelector('#CartDrawer');
    if (drawerInner) {
      drawerObserver.observe(drawerInner, { childList: true, subtree: true });
    }
  }
  document.addEventListener('DOMContentLoaded', function() {
    addNavLinks();
    startObserver();
  });

  /* ── 2. Fetch-Interceptor: Drawer nach ATC öffnen ── */
  const _fetch = window.fetch;
  window.fetch = function(input, init) {
    const url = (typeof input === 'string') ? input : (input && input.url) || '';
    const method = (init && init.method) ? init.method.toUpperCase() : 'GET';
    const isATC = method === 'POST' && /\/cart\/add(\.json|\.js)?(\?|$)/.test(url);
    return _fetch.apply(this, arguments).then(function(response) {
      if (isATC && response.ok) {
        setTimeout(openCartDrawer, 200);
      }
      return response;
    });
  };

  /* ── 3. Drawer öffnen & Inhalt aktualisieren ── */
  function openCartDrawer() {
    fetch('/cart?sections=cart-drawer,cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newInner = doc.querySelector('#CartDrawer');
          const existing = document.querySelector('#CartDrawer');
          if (newInner && existing) {
            existing.innerHTML = newInner.innerHTML;
          }
        }
        if (data['cart-icon-bubble']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          const newBubble = doc.querySelector('.cart-count-bubble');
          const existingBubble = document.querySelector('.cart-count-bubble');
          if (newBubble && existingBubble) {
            existingBubble.innerHTML = newBubble.innerHTML;
          }
        }
        addNavLinks();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(null);
        }
      })
      .catch(function(err) {
        console.warn('[calo-cart] Drawer open failed:', err);
      });
  }

  /* ── 4. "JETZT KAUFEN" → direkt zum Checkout ── */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-calo-buy-now], .calo-buy-now, .gp-btn[data-action="buy-now"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/checkout';
  }, true);

})();
